/**
 * Exercise Library
 *
 * Comprehensive database of exercises organized by muscle group.
 * Each exercise includes default sets and reps for programming convenience.
 */

export interface Exercise {
  name: string;
  defaultSets: number;
  defaultReps: number;
}

export const EXERCISE_LIBRARY: Record<string, Exercise[]> = {
  Chest: [
    { name: "Flat Barbell Bench Press", defaultSets: 4, defaultReps: 8 },
    { name: "Incline Barbell Bench Press", defaultSets: 4, defaultReps: 8 },
    { name: "Decline Barbell Bench Press", defaultSets: 3, defaultReps: 8 },
    { name: "Flat Dumbbell Press", defaultSets: 3, defaultReps: 10 },
    { name: "Incline Dumbbell Press", defaultSets: 3, defaultReps: 10 },
    { name: "Decline Dumbbell Press", defaultSets: 3, defaultReps: 10 },
    { name: "Machine Flat Bench Press", defaultSets: 3, defaultReps: 10 },
    { name: "Machine Incline Press", defaultSets: 3, defaultReps: 10 },
    { name: "Machine Decline Press", defaultSets: 3, defaultReps: 10 },
    { name: "Smith Machine Bench Press", defaultSets: 3, defaultReps: 8 },
    { name: "Smith Machine Incline Press", defaultSets: 3, defaultReps: 8 },
    { name: "Cable Flyes (Mid)", defaultSets: 3, defaultReps: 12 },
    { name: "Cable Flyes (Low-to-High)", defaultSets: 3, defaultReps: 12 },
    { name: "Cable Flyes (High-to-Low)", defaultSets: 3, defaultReps: 12 },
    { name: "Dumbbell Flyes (Flat)", defaultSets: 3, defaultReps: 12 },
    { name: "Dumbbell Flyes (Incline)", defaultSets: 3, defaultReps: 12 },
    { name: "Pec Deck Machine", defaultSets: 3, defaultReps: 12 },
    { name: "Chest Dips", defaultSets: 3, defaultReps: 10 },
    { name: "Push-Ups", defaultSets: 3, defaultReps: 15 },
    { name: "Diamond Push-Ups", defaultSets: 3, defaultReps: 12 },
    { name: "Incline Push-Ups", defaultSets: 3, defaultReps: 15 },
    { name: "Decline Push-Ups", defaultSets: 3, defaultReps: 12 },
    { name: "Weighted Push-Ups", defaultSets: 3, defaultReps: 10 },
    { name: "Landmine Press", defaultSets: 3, defaultReps: 10 },
    { name: "Svend Press", defaultSets: 3, defaultReps: 12 },
    { name: "Floor Press (Barbell)", defaultSets: 3, defaultReps: 8 },
    { name: "Floor Press (Dumbbell)", defaultSets: 3, defaultReps: 10 },
  ],
  Back: [
    { name: "Conventional Deadlift", defaultSets: 4, defaultReps: 5 },
    { name: "Sumo Deadlift", defaultSets: 4, defaultReps: 5 },
    { name: "Trap Bar Deadlift", defaultSets: 4, defaultReps: 6 },
    { name: "Rack Pull", defaultSets: 3, defaultReps: 6 },
    { name: "Barbell Row (Overhand)", defaultSets: 4, defaultReps: 8 },
    { name: "Barbell Row (Underhand)", defaultSets: 4, defaultReps: 8 },
    { name: "Pendlay Row", defaultSets: 4, defaultReps: 6 },
    { name: "T-Bar Row", defaultSets: 3, defaultReps: 8 },
    { name: "Single Arm Dumbbell Row", defaultSets: 3, defaultReps: 10 },
    { name: "Chest-Supported Dumbbell Row", defaultSets: 3, defaultReps: 10 },
    { name: "Seated Cable Row (Close Grip)", defaultSets: 3, defaultReps: 10 },
    { name: "Seated Cable Row (Wide Grip)", defaultSets: 3, defaultReps: 10 },
    { name: "Machine Row (Plate Loaded)", defaultSets: 3, defaultReps: 10 },
    { name: "Machine Row (Selectorized)", defaultSets: 3, defaultReps: 10 },
    { name: "Pull-Ups", defaultSets: 3, defaultReps: 8 },
    { name: "Chin-Ups", defaultSets: 3, defaultReps: 8 },
    { name: "Neutral Grip Pull-Ups", defaultSets: 3, defaultReps: 8 },
    { name: "Weighted Pull-Ups", defaultSets: 3, defaultReps: 6 },
    { name: "Lat Pulldown (Wide)", defaultSets: 3, defaultReps: 10 },
    { name: "Lat Pulldown (Close/V-Bar)", defaultSets: 3, defaultReps: 10 },
    { name: "Lat Pulldown (Reverse Grip)", defaultSets: 3, defaultReps: 10 },
    { name: "Lat Pulldown (Single Arm)", defaultSets: 3, defaultReps: 10 },
    { name: "Straight Arm Pulldown", defaultSets: 3, defaultReps: 12 },
    { name: "Face Pulls", defaultSets: 3, defaultReps: 15 },
    { name: "Meadows Row", defaultSets: 3, defaultReps: 10 },
    { name: "Seal Row", defaultSets: 3, defaultReps: 10 },
    { name: "Inverted Row", defaultSets: 3, defaultReps: 12 },
    { name: "Hyperextensions / Back Extension", defaultSets: 3, defaultReps: 12 },
    { name: "Good Mornings", defaultSets: 3, defaultReps: 10 },
    { name: "Cable Pullover", defaultSets: 3, defaultReps: 12 },
    { name: "Dumbbell Pullover", defaultSets: 3, defaultReps: 10 },
  ],
  Traps: [
    { name: "Barbell Shrugs", defaultSets: 4, defaultReps: 12 },
    { name: "Dumbbell Shrugs", defaultSets: 4, defaultReps: 12 },
    { name: "Trap Bar Shrugs", defaultSets: 4, defaultReps: 12 },
    { name: "Smith Machine Shrugs", defaultSets: 3, defaultReps: 12 },
    { name: "Cable Shrugs", defaultSets: 3, defaultReps: 15 },
    { name: "Behind-the-Back Barbell Shrugs", defaultSets: 3, defaultReps: 12 },
    { name: "Overhead Barbell Shrugs", defaultSets: 3, defaultReps: 10 },
    { name: "Face Pulls (High)", defaultSets: 3, defaultReps: 15 },
    { name: "Upright Row (Wide Grip)", defaultSets: 3, defaultReps: 10 },
    { name: "Farmer's Walk", defaultSets: 3, defaultReps: 40 },
    { name: "Rack Pulls (Above Knee)", defaultSets: 3, defaultReps: 6 },
    { name: "Prone Y Raise", defaultSets: 3, defaultReps: 12 },
  ],
  Shoulders: [
    { name: "Barbell Overhead Press", defaultSets: 4, defaultReps: 8 },
    { name: "Dumbbell Overhead Press", defaultSets: 3, defaultReps: 10 },
    { name: "Seated Dumbbell Press", defaultSets: 3, defaultReps: 10 },
    { name: "Arnold Press", defaultSets: 3, defaultReps: 10 },
    { name: "Machine Shoulder Press", defaultSets: 3, defaultReps: 10 },
    { name: "Smith Machine Shoulder Press", defaultSets: 3, defaultReps: 8 },
    { name: "Push Press", defaultSets: 4, defaultReps: 6 },
    { name: "Landmine Shoulder Press", defaultSets: 3, defaultReps: 10 },
    { name: "Dumbbell Lateral Raises", defaultSets: 3, defaultReps: 12 },
    { name: "Cable Lateral Raises", defaultSets: 3, defaultReps: 12 },
    { name: "Machine Lateral Raises", defaultSets: 3, defaultReps: 12 },
    { name: "Leaning Cable Lateral Raise", defaultSets: 3, defaultReps: 12 },
    { name: "Front Raises (Dumbbell)", defaultSets: 3, defaultReps: 12 },
    { name: "Front Raises (Cable)", defaultSets: 3, defaultReps: 12 },
    { name: "Front Raises (Plate)", defaultSets: 3, defaultReps: 12 },
    { name: "Rear Delt Flyes (Dumbbell)", defaultSets: 3, defaultReps: 12 },
    { name: "Rear Delt Flyes (Cable)", defaultSets: 3, defaultReps: 12 },
    { name: "Rear Delt Flyes (Machine)", defaultSets: 3, defaultReps: 12 },
    { name: "Upright Row (Barbell)", defaultSets: 3, defaultReps: 10 },
    { name: "Upright Row (Dumbbell)", defaultSets: 3, defaultReps: 10 },
    { name: "Upright Row (Cable)", defaultSets: 3, defaultReps: 10 },
    { name: "Lu Raises", defaultSets: 3, defaultReps: 10 },
    { name: "Bradford Press", defaultSets: 3, defaultReps: 10 },
    { name: "Behind-the-Neck Press", defaultSets: 3, defaultReps: 8 },
    { name: "Face Pulls", defaultSets: 3, defaultReps: 15 },
    { name: "Bottoms-Up Kettlebell Press", defaultSets: 3, defaultReps: 8 },
  ],
  Legs: [
    { name: "Back Squat", defaultSets: 4, defaultReps: 8 },
    { name: "Front Squat", defaultSets: 4, defaultReps: 6 },
    { name: "Goblet Squat", defaultSets: 3, defaultReps: 10 },
    { name: "Hack Squat (Machine)", defaultSets: 3, defaultReps: 10 },
    { name: "Smith Machine Squat", defaultSets: 3, defaultReps: 8 },
    { name: "Belt Squat", defaultSets: 3, defaultReps: 10 },
    { name: "Zercher Squat", defaultSets: 3, defaultReps: 8 },
    { name: "Leg Press", defaultSets: 4, defaultReps: 10 },
    { name: "Leg Press (Single Leg)", defaultSets: 3, defaultReps: 10 },
    { name: "Pendulum Squat", defaultSets: 3, defaultReps: 10 },
    { name: "V-Squat Machine", defaultSets: 3, defaultReps: 10 },
    { name: "Romanian Deadlift (Barbell)", defaultSets: 3, defaultReps: 10 },
    { name: "Romanian Deadlift (Dumbbell)", defaultSets: 3, defaultReps: 10 },
    { name: "Stiff-Leg Deadlift", defaultSets: 3, defaultReps: 10 },
    { name: "Single-Leg Romanian Deadlift", defaultSets: 3, defaultReps: 10 },
    { name: "Walking Lunges", defaultSets: 3, defaultReps: 12 },
    { name: "Reverse Lunges", defaultSets: 3, defaultReps: 10 },
    { name: "Stationary Lunges", defaultSets: 3, defaultReps: 10 },
    { name: "Bulgarian Split Squat", defaultSets: 3, defaultReps: 10 },
    { name: "Step-Ups", defaultSets: 3, defaultReps: 10 },
    { name: "Leg Extension", defaultSets: 3, defaultReps: 12 },
    { name: "Single-Leg Extension", defaultSets: 3, defaultReps: 12 },
    { name: "Lying Leg Curl", defaultSets: 3, defaultReps: 12 },
    { name: "Seated Leg Curl", defaultSets: 3, defaultReps: 12 },
    { name: "Standing Leg Curl", defaultSets: 3, defaultReps: 12 },
    { name: "Nordic Hamstring Curl", defaultSets: 3, defaultReps: 6 },
    { name: "Glute-Ham Raise", defaultSets: 3, defaultReps: 8 },
    { name: "Hip Thrust (Barbell)", defaultSets: 3, defaultReps: 10 },
    { name: "Hip Thrust (Machine)", defaultSets: 3, defaultReps: 10 },
    { name: "Hip Thrust (Single Leg)", defaultSets: 3, defaultReps: 10 },
    { name: "Cable Pull-Through", defaultSets: 3, defaultReps: 12 },
    { name: "Glute Kickback (Cable)", defaultSets: 3, defaultReps: 12 },
    { name: "Glute Kickback (Machine)", defaultSets: 3, defaultReps: 12 },
    { name: "Hip Abductor Machine", defaultSets: 3, defaultReps: 12 },
    { name: "Hip Adductor Machine", defaultSets: 3, defaultReps: 12 },
    { name: "Sissy Squat", defaultSets: 3, defaultReps: 12 },
    { name: "Box Squat", defaultSets: 3, defaultReps: 8 },
  ],
  Calves: [
    { name: "Standing Calf Raise (Machine)", defaultSets: 4, defaultReps: 15 },
    { name: "Standing Calf Raise (Smith Machine)", defaultSets: 4, defaultReps: 15 },
    { name: "Standing Calf Raise (Dumbbell)", defaultSets: 3, defaultReps: 15 },
    { name: "Standing Calf Raise (Barbell)", defaultSets: 3, defaultReps: 15 },
    { name: "Seated Calf Raise", defaultSets: 4, defaultReps: 15 },
    { name: "Leg Press Calf Raise", defaultSets: 3, defaultReps: 15 },
    { name: "Donkey Calf Raise", defaultSets: 3, defaultReps: 15 },
    { name: "Single-Leg Calf Raise", defaultSets: 3, defaultReps: 12 },
    { name: "Tibialis Raise", defaultSets: 3, defaultReps: 15 },
  ],
  Biceps: [
    { name: "Barbell Curl", defaultSets: 3, defaultReps: 10 },
    { name: "EZ-Bar Curl", defaultSets: 3, defaultReps: 10 },
    { name: "Dumbbell Curl (Standing)", defaultSets: 3, defaultReps: 10 },
    { name: "Dumbbell Curl (Seated Incline)", defaultSets: 3, defaultReps: 10 },
    { name: "Hammer Curls", defaultSets: 3, defaultReps: 10 },
    { name: "Cross-Body Hammer Curls", defaultSets: 3, defaultReps: 10 },
    { name: "Concentration Curls", defaultSets: 3, defaultReps: 12 },
    { name: "Preacher Curls (Barbell)", defaultSets: 3, defaultReps: 10 },
    { name: "Preacher Curls (Dumbbell)", defaultSets: 3, defaultReps: 10 },
    { name: "Preacher Curls (Machine)", defaultSets: 3, defaultReps: 10 },
    { name: "Cable Curl (Straight Bar)", defaultSets: 3, defaultReps: 12 },
    { name: "Cable Curl (Rope)", defaultSets: 3, defaultReps: 12 },
    { name: "Spider Curls", defaultSets: 3, defaultReps: 10 },
    { name: "Reverse Curls (Barbell)", defaultSets: 3, defaultReps: 12 },
    { name: "Reverse Curls (EZ-Bar)", defaultSets: 3, defaultReps: 12 },
    { name: "Bayesian Cable Curl", defaultSets: 3, defaultReps: 12 },
    { name: "21s (Barbell Curl)", defaultSets: 3, defaultReps: 21 },
    { name: "Drag Curl", defaultSets: 3, defaultReps: 10 },
    { name: "Zottman Curl", defaultSets: 3, defaultReps: 10 },
  ],
  Triceps: [
    { name: "Tricep Pushdown (Rope)", defaultSets: 3, defaultReps: 12 },
    { name: "Tricep Pushdown (V-Bar)", defaultSets: 3, defaultReps: 12 },
    { name: "Tricep Pushdown (Straight Bar)", defaultSets: 3, defaultReps: 12 },
    { name: "Skull Crushers (Barbell)", defaultSets: 3, defaultReps: 10 },
    { name: "Skull Crushers (EZ-Bar)", defaultSets: 3, defaultReps: 10 },
    { name: "Skull Crushers (Dumbbell)", defaultSets: 3, defaultReps: 10 },
    { name: "Overhead Tricep Extension (Cable)", defaultSets: 3, defaultReps: 12 },
    { name: "Overhead Tricep Extension (Dumbbell)", defaultSets: 3, defaultReps: 10 },
    { name: "Overhead Tricep Extension (EZ-Bar)", defaultSets: 3, defaultReps: 10 },
    { name: "Close-Grip Bench Press", defaultSets: 3, defaultReps: 8 },
    { name: "Tricep Dips", defaultSets: 3, defaultReps: 10 },
    { name: "Tricep Kickbacks (Dumbbell)", defaultSets: 3, defaultReps: 12 },
    { name: "Tricep Kickbacks (Cable)", defaultSets: 3, defaultReps: 12 },
    { name: "JM Press", defaultSets: 3, defaultReps: 8 },
    { name: "Diamond Push-Ups", defaultSets: 3, defaultReps: 12 },
    { name: "Bench Dips", defaultSets: 3, defaultReps: 12 },
    { name: "Single-Arm Pushdown", defaultSets: 3, defaultReps: 12 },
  ],
  Forearms: [
    { name: "Wrist Curl (Barbell)", defaultSets: 3, defaultReps: 15 },
    { name: "Wrist Curl (Dumbbell)", defaultSets: 3, defaultReps: 15 },
    { name: "Reverse Wrist Curl", defaultSets: 3, defaultReps: 15 },
    { name: "Farmer's Walk", defaultSets: 3, defaultReps: 40 },
    { name: "Plate Pinch Hold", defaultSets: 3, defaultReps: 30 },
    { name: "Dead Hang", defaultSets: 3, defaultReps: 30 },
    { name: "Fat Grip Curl", defaultSets: 3, defaultReps: 10 },
    { name: "Behind-the-Back Wrist Curl", defaultSets: 3, defaultReps: 15 },
  ],
  Core: [
    { name: "Plank", defaultSets: 3, defaultReps: 60 },
    { name: "Side Plank", defaultSets: 3, defaultReps: 30 },
    { name: "Hanging Leg Raise", defaultSets: 3, defaultReps: 12 },
    { name: "Hanging Knee Raise", defaultSets: 3, defaultReps: 15 },
    { name: "Captain's Chair Leg Raise", defaultSets: 3, defaultReps: 12 },
    { name: "Cable Crunch", defaultSets: 3, defaultReps: 15 },
    { name: "Ab Wheel Rollout", defaultSets: 3, defaultReps: 10 },
    { name: "Russian Twists", defaultSets: 3, defaultReps: 20 },
    { name: "Bicycle Crunches", defaultSets: 3, defaultReps: 20 },
    { name: "Decline Sit-Ups", defaultSets: 3, defaultReps: 15 },
    { name: "Weighted Sit-Ups", defaultSets: 3, defaultReps: 12 },
    { name: "Machine Crunch", defaultSets: 3, defaultReps: 15 },
    { name: "Pallof Press", defaultSets: 3, defaultReps: 12 },
    { name: "Cable Woodchop", defaultSets: 3, defaultReps: 12 },
    { name: "Dragon Flags", defaultSets: 3, defaultReps: 6 },
    { name: "Dead Bug", defaultSets: 3, defaultReps: 12 },
    { name: "Bird Dog", defaultSets: 3, defaultReps: 12 },
    { name: "L-Sit Hold", defaultSets: 3, defaultReps: 20 },
    { name: "Toes to Bar", defaultSets: 3, defaultReps: 10 },
    { name: "Suitcase Carry", defaultSets: 3, defaultReps: 40 },
  ],
};

/**
 * Compound Exercise Secondary Muscle Groups
 *
 * Maps compound exercises to the secondary muscle groups they target.
 * Used for intelligent workout programming and recovery management.
 */
export const COMPOUND_SECONDARY: Record<string, string[]> = {
  "Flat Barbell Bench Press": ["Shoulders", "Triceps"],
  "Incline Barbell Bench Press": ["Shoulders", "Triceps"],
  "Decline Barbell Bench Press": ["Shoulders", "Triceps"],
  "Flat Dumbbell Press": ["Shoulders", "Triceps"],
  "Incline Dumbbell Press": ["Shoulders", "Triceps"],
  "Conventional Deadlift": ["Back", "Legs", "Core"],
  "Sumo Deadlift": ["Back", "Legs", "Core"],
  "Trap Bar Deadlift": ["Back", "Legs", "Core"],
  "Barbell Row (Overhand)": ["Biceps", "Core"],
  "Barbell Row (Underhand)": ["Biceps", "Core"],
  "Pendlay Row": ["Biceps", "Core"],
  "Pull-Ups": ["Biceps"],
  "Chin-Ups": ["Biceps"],
  "Weighted Pull-Ups": ["Biceps"],
  "Barbell Overhead Press": ["Triceps", "Core"],
  "Dumbbell Overhead Press": ["Triceps", "Core"],
  "Back Squat": ["Core", "Calves"],
  "Front Squat": ["Core"],
  "Chest Dips": ["Triceps", "Shoulders"],
  "Dips (Tricep Focus)": ["Chest", "Shoulders"],
};

/**
 * Get the primary category for an exercise
 *
 * Performs intelligent fuzzy matching using multiple strategies:
 * 1. Exact match
 * 2. Prefix matching (either direction)
 * 3. Substring matching
 * 4. Word overlap matching
 *
 * @param name - Exercise name to look up
 * @param customMap - Optional override map for custom exercises
 * @returns The category name, or "Other" if not found
 */
export function getExerciseCategory(
  name: string,
  customMap?: Record<string, string>
): string {
  if (!name) return "Other";

  // Check custom override first
  if (customMap && customMap[name]) {
    return customMap[name];
  }

  // Build reverse lookup from EXERCISE_LIBRARY
  const exCatMap: Record<string, string> = {};
  Object.entries(EXERCISE_LIBRARY).forEach(([cat, exs]) => {
    exs.forEach((ex) => {
      exCatMap[ex.name] = cat;
    });
  });

  // 1. Exact match
  if (exCatMap[name]) {
    return exCatMap[name];
  }

  const lc = name.toLowerCase();
  if (!lc) return "Other";

  // 2. Prefix match (either direction)
  for (const k in exCatMap) {
    const kl = k.toLowerCase();
    if (kl.startsWith(lc) || lc.startsWith(kl)) {
      return exCatMap[k];
    }
  }

  // 3. Substring match: "Lateral Raises" found inside "Dumbbell Lateral Raises"
  for (const k in exCatMap) {
    const kl = k.toLowerCase();
    if (kl.includes(lc) || lc.includes(kl)) {
      return exCatMap[k];
    }
  }

  // 4. Word overlap: all significant words in input appear in a library entry
  const words = lc.split(/\s+/).filter((w) => w.length > 2);
  if (words.length > 0) {
    let best: string | null = null;
    let bestCount = 0;

    for (const k in exCatMap) {
      const kl = k.toLowerCase();
      let count = 0;
      words.forEach((w) => {
        if (kl.includes(w)) count++;
      });

      if (count > bestCount) {
        bestCount = count;
        best = k;
      }
    }

    if (best && bestCount >= Math.max(1, Math.ceil(words.length / 2))) {
      return exCatMap[best];
    }
  }

  return "Other";
}
